export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Éduc Spé à Domicile",
    url: "https://educspe.be",
    logo: "https://educspe.be/img/logo.941bf0cb.png",
    image: "https://educspe.be/img/logo.941bf0cb.png",
    telephone: "+32470510391",
    areaServed: {
      "@type": "Country",
      name: "Belgique",
    },
    areaServed: [
      {
        "@type": "ServiceAreaBusiness",
        name: "Belgique",
      },
      {
        "@type": "AdministrativeArea",
        name: "Région de Bruxelles-Capitale",
      },
      {
        "@type": "ServiceAreaBusiness",
        name: "Brabant wallon",
      },
      {
        "@type": "ServiceAreaBusiness",
        name: "Flandre",
      },
    ],
    availableService: [
      {
        "@type": "MedicalService",
        name: "Accompagnement palliatif à domicile",
        description:
          "Présence humaine continue, accompagnement palliatif et soutien des familles.",
      },
      {
        "@type": "MedicalService",
        name: "Situations complexes et urgences",
        description:
          "Interventions rapides 24h/24 pour situations médicales ou psychologiques complexes.",
      },
      {
        "@type": "MedicalService",
        name: "Soins de bien-être et socio-esthétique",
        description:
          "Pédicure médicale, manucure, soins du visage et massages relaxants pour personnes fragilisées.",
      },
      {
        "@type": "MedicalService",
        name: "Accompagnement des personnes âgées et troubles cognitifs",
        description:
          "Soutien quotidien, stimulation cognitive, prévention des chutes et accompagnement personnalisé.",
      },
      {
        "@type": "MedicalService",
        name: "Adultes en perte d’autonomie et situation de handicap",
        description:
          "Accompagnement éducatif, sécuritaire et social à domicile.",
      },
      {
        "@type": "MedicalService",
        name: "Enfants et adolescents",
        description:
          "Accompagnement éducatif spécialisé pour enfants et adolescents ayant des besoins spécifiques.",
      },
      {
        "@type": "MedicalService",
        name: "Accompagnement en institutions",
        description:
          "Interventions en maisons de repos, hôpitaux et résidences-services.",
      },
      {
        "@type": "MedicalService",
        name: "Voyages et résidences secondaires",
        description:
          "Accompagnement lors de séjours temporaires, déplacements et résidences secondaires.",
      },
      {
        "@type": "MedicalService",
        name: "Mise au lit tardive",
        description:
          "Service de soirée respectant le rythme et les habitudes de vie des bénéficiaires.",
      },
      {
        "@type": "MedicalService",
        name: "Espace Aquasensoriel",
        description:
          "Accompagnement aquatique psychoéducatif adapté en milieu chauffé pour personnes âgées, en situation de handicap, enfants TSA et personnes fragilisées.",
      },
    ],
    employee: {
      "@type": "MedicalAudience",
      audienceType: [
        "Éducateurs spécialisés",
        "Aides-soignants",
        "Professionnels du soin et du bien-être",
      ],
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "00:00",
      closes: "23:59",
    },
    description:
      "ÉducSpé à Domicile propose un accompagnement humain, sécurisant et personnalisé 24h/24, 7j/7, à domicile et en institution.",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "Service client",
      availableLanguage: ["French"],
      areaServed: "BE",
      url: "https://educspe.be/contact",
      email: "contact@educspe.be",
      telephone: "+32470510391",
    },
  };
}
